import { Route } from "react-router-dom";
import ProtectedRoute from "src/routes/middlewares/ProtectedRoute";
import EnableTenantAccessView from "src/views/global/EnableTenantAccessView";
import NotActivatedView from "src/views/global/NotActivatedView";
import TermsOfServiceView from "src/views/global/TermsOfServiceView";

const GlobalRoutes = [
	<Route
		element={<EnableTenantAccessView />}
		path="/enable-access"
		key="/enable-access"
	/>,
	<Route
		element={<NotActivatedView />}
		path="/not-activated"
		key="/not-activated"
	/>,
	<Route
		element={
			<ProtectedRoute>
				<TermsOfServiceView />
			</ProtectedRoute>
		}
		path="/terms-of-service"
		key="/terms-of-service"
	/>,
];

export default GlobalRoutes;
